import { MOCK_SUPPORTER_MIXED_COMMITMENTS } from './mocks/supporters';

export const QUERY_KEYS = {
  supporterPaymentMethods: 'supporterPaymentMethods',
  supporterCommitments: 'supporterCommitments',
  supporterAddress: 'supporterAddress',
  supporterGivingHistory: 'supporterGivingHistory',
  supporterPledges: 'supporterPledges',
  supporterTaxReceipts: 'supporterTaxReceipts',
};

export const MUTATION_KEYS = {
  paymentMethodRemove: 'paymentMethodRemove',
};

export const MOCK_SUPPORTER =
  process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER &&
  process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER !== 'false'
    ? MOCK_SUPPORTER_MIXED_COMMITMENTS
    : null;
